import { InjectionToken, ValueProvider } from '@angular/core';
import { google } from 'google-maps';

interface GoogleMaps {
  getGoogle: () => google;
}

declare let window: {
  google: google;
};

const getGoogle = () => window.google;

const GOOGLE_MAPS: InjectionToken<GoogleMaps> = new InjectionToken<GoogleMaps>(
  'GoogleMaps',
);
const GOOGLE_MAPS_PROVIDER: ValueProvider = {
  provide: GOOGLE_MAPS,
  useValue: { getGoogle },
};

export { GoogleMaps, GOOGLE_MAPS, GOOGLE_MAPS_PROVIDER };
